import { Guid } from "@/Common/Models/Guid";
import { PatientTab } from "@/Common/Models/Patient/PatientEnums";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { ActionCreator } from "@/Flowsheets/Hooks/useDispatch";
import { FlowsheetSummary } from "@/Flowsheets/Models/FlowsheetSummary";
import { Flowsheet } from "../Models/Flowsheet";
import { FlowsheetTemplate } from "../Models/FlowsheetTemplate";

interface INavigateToFlowsheetModulePayload {
    value: PatientTab,
    isFlowsheetTabActive: boolean,
    flowsheetSummary: FlowsheetSummary
}

const navigateToFlowsheetFromSummariesAction: ActionCreator<INavigateToFlowsheetModulePayload> = (flowsheetSummary: FlowsheetSummary) => ({
    operation: LocalPatientOperations.UI.ChangeVerticalTabs,
    payload: {
        value: PatientTab.Flowsheet,
        isFlowsheetTabActive: true,
        flowsheetSummary: flowsheetSummary
    }
});

const addFlowsheetSummaryStoreAction: ActionCreator<{ flowsheet: FlowsheetSummary }> = (flowsheetSummary: FlowsheetSummary) => ({
    operation: LocalPatientOperations.Flowsheets.AddFlowsheetSummary,
    payload: {
        flowsheet: flowsheetSummary
    }
});

const saveFlowsheetStoreAction: ActionCreator<{ patientId: Guid, flowsheet: Flowsheet, template: FlowsheetTemplate }> = (patientId: Guid, flowsheet: Flowsheet, template: FlowsheetTemplate) => ({
    operation: LocalPatientOperations.Flowsheets.SaveFlowsheet,
    payload: {
        patientId,
        flowsheet,
        template
    }
});

const deleteFlowsheetStoreAction: ActionCreator<{ flowsheetId: Guid, encounterId: Guid }> = (payload: { flowsheetId: Guid, encounterId: Guid }) => ({
    operation: LocalPatientOperations.Flowsheets.DeleteFlowsheet,
    payload
});

const setForceReloadStoreAction: ActionCreator<{ patientId: string, value: boolean }> = (payload: { patientId: string, value: boolean }) => ({
    operation: LocalPatientOperations.Flowsheets.SetForceReload,
    payload
});

export { addFlowsheetSummaryStoreAction, deleteFlowsheetStoreAction, navigateToFlowsheetFromSummariesAction, saveFlowsheetStoreAction, setForceReloadStoreAction };
